export const EDUCATOR = 'educator';
export const STUDENT = 'student';
export const STAFF = 'staff';

export const providers = {
  HAND_IN: 'hand-in',
  TURNITIN: 'turnitin',
  MANUAL: 'manual',
  QUIZZES: 'quizzes',
  LTI_1P3: 'lti-1p3',
};

export const jobStatus = {
  START: 'START',
  DONE: 'DONE',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
};

export const gradeTypeTitles = {
  freeform: 'Free form',
  percentage: 'Percentages',
  rubric: 'Rubric',
  passFail: 'Pass/Fail',
  letterGrade: 'Letter grade',
  points: 'Points',
};

export const gradeTypes = {
  percentage: 'percentage',
  freeform: 'freeform',
  rubric: 'rubric',
  passFail: 'passFail',
  letterGrade: 'letterGrade',
};
